import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const suffix: AnswerPathTreeNode = { path: 'suffix', nodeId: NodeIds.insuredSuffix };
